import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { getCurrentInstance } from "@vue/runtime-core";
import { useMessage } from "naive-ui";


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageWrapper',
  setup(__props) {

const app = getCurrentInstance()
app!.appContext.config.globalProperties.message = useMessage()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})